/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Field_Password_LabelInputs */

const en_auth_field_password_label = /** @type {(inputs: Auth_Field_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password`)
};

const pl_auth_field_password_label = /** @type {(inputs: Auth_Field_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasło`)
};

/**
* | output |
* | --- |
* | "Password" |
*
* @param {Auth_Field_Password_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_field_password_label = /** @type {((inputs?: Auth_Field_Password_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Field_Password_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_field_password_label(inputs)
	return en_auth_field_password_label(inputs)
});